import { render } from "./payConfirm.vue?vue&type=template&id=a1f43b50&scoped=true"
import script from "./payConfirm.vue?vue&type=script&lang=js"
export * from "./payConfirm.vue?vue&type=script&lang=js"

import "./payConfirm.vue?vue&type=style&index=0&id=a1f43b50&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f43b50"]])

export default __exports__